const INTERNAL_ERROR = 'INTERNAL_ERROR';
const DEFAULT_ERROR = INTERNAL_ERROR;

export class RequestException extends Error {
    status: number;

    code: string;

    url: string;

    rcid?: string;

    errorName: string;

    developerMessage?: string;

    type: string;

    constructor(response: Response) {
        super(response.statusText);

        this.name = this.constructor.name;
        this.status = response.status;
        this.code = response.status.toString(10);

        this.url = response.url;
        this.rcid = undefined;
        this.errorName = response.statusText;
        this.developerMessage = undefined;

        this.type = DEFAULT_ERROR;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RequestException);
        }
    }
}

export interface ErrorResponse {
    code: string;
    requestCorrelationId?: {
        value: string;
    };
    name: string;
    developerMessage?: string;
    type: string;
    message: string;
}
